export const extractMembers = (members) => {
    return members.map((member) => member.publicUserData.firstName);
}